export default __webpack_public_path__ + "assets/images/6f6815f9320a8e66c6cfad971b231142-instructions-account-reset.gif";